export const timePicker = {
  clockIcon: {
    alt: 'Open clock'
  },
  clearIcon: {
    alt: 'Clear time'
  }
};
